import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  selectedWidget: {},
  combinationdatas: {},
  CombinationListData: [],
  defaultLang:'',
  languageData:[],
  isOpenWidget:false,
  languageId:null

};
export const CombinationSlice = createSlice({
  name: "Combination",
  initialState,
  reducers: {
    setLanguageID:(state, action) => {
      state.languageId = action.payload
    },
    updateCombinationdatas: (state, action) => {
      state.combinationdatas = action.payload;
    },
    updateSelectedWidget: (state, action) => {
      state.selectedWidget = action.payload;
    },
    updateCombinationListData: (state, action) => {
      state.CombinationListData = action.payload;
    },
    updateDefaultLanguage:(state,action)=>{
      state.defaultLang=action.payload;
    },
    updateLanguageData:(state,action)=>{
      state.languageData=action.payload;
    },
    setIsOpenWidget:(state, action) => {
      state.isOpenWidget = action.payload
    },

  },
});
export const {
  updateCombinationdatas,
  updateSelectedWidget,
  updateCombinationListData,
  updateDefaultLanguage,
  updateLanguageData,
  setIsOpenWidget,
  setLanguageID
} = CombinationSlice.actions;

export default CombinationSlice.reducer;
